import { useEffect, useState } from 'react';
import Modal from '../../../../components/modal/modal';
import '../../../../components/modal/modal.scss';
import CustomTable from '../../../../components/table/table';
import { toUSD } from '../../../../util/currency-formatter';

export const UpdateMaterialDialog = ({
	show,
	onHide,
	onUpdate,
	materials = [],
	mappers,
}) => {
	const [updatedMaterials, setUpdatedMaterials] = useState([]);

	// Initialize updatedMaterials when materials or mappers change
	useEffect(() => {
		setUpdatedMaterials(
			materials.map((mat) => ({
				...mat,
				newCost: mat[mappers.cost.key] || 0,
			}))
		);
	}, [materials, mappers]);

	// Handle input change for newCost field
	const handleCostChange = (index, value) => {
		const updated = [...updatedMaterials];
		updated[index].newCost = value;
		setUpdatedMaterials(updated);
	};

	// Define table columns
	const getColumns = () => [
		{
			title: mappers.item.label,
			field: mappers.item.key,
			filtering: false,
		},
		{
			title: mappers.partNo.label,
			field: mappers.partNo.key,
			filtering: false,
		},
		{
			title: mappers.manufacturer.label,
			field: mappers.manufacturer.key,
			filtering: false,
			render: (data) =>
				data[mappers.manufacturer.key] || mappers.manufacturer.default,
		},
		{
			title: 'Current Cost',
			field: mappers.cost.key,
			filtering: false,
			class: 'text-right',
			render: (data) =>
				toUSD(
					Number(
						(data[mappers.cost.key] || '')
							.toString()
							.trim()
							.replace(/[^0-9.-]+/g, '')
					)
				),
		},
		{
			title: 'New Cost',
			field: 'newCost',
			filtering: false,
			render: (data) => {
				const index = updatedMaterials.findIndex(mat => mat[mappers.item.key] === data[mappers.item.key]);

				return (
					<input
						type="number"
						className="form-control-input"
						value={data.newCost}
						onChange={(e) => handleCostChange(index, parseFloat(e.target.value) || 0)}
						min="0.001"
						step="0.01"
					/>
				)
			},
		},
	];

	return (
		<Modal
			open={show}
			onClose={onHide}
			fullWidth={true}
			maxWidth='lg'
			modalHeading={`Update Material (${materials.length} items)`}
			modalSaveTxt='Save'
			modalCloseTxt='Cancel'
			onClick={() => onUpdate(updatedMaterials)}
			showActionBtn
			savebtnClass='createBtn'
			cxlbtnClass='cancelBtn'
			primary
		>
			<CustomTable
				toolbar={false}
				enableSearch={false}
				columns={getColumns()}
				data={updatedMaterials}
				fileName="materials-update"
				limit={5}
			/>
		</Modal>
	);
};
